import { Button, Modal, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdLibraryAdd } from "react-icons/md";
import styled from "styled-components";
import api from "../../services/api";
import CustomTooltip from "../CustomTooltip";
import {
  ActionsContainer,
  ModalBody,
  SearchContainer,
  StyledTable,
  TableContainer
} from "../style/assign-device-modal.styled";
import { ToastError, ToastSuccess } from "../toaster/toast.utils";

interface AssignDeviceModalProps {
  open: boolean;
  onClose: () => void;
  onDeviceAssigned: () => void;
  clientId: number;
  workOrderId: string;
}

const TableHeader = styled.th``; // mantém só pra semântica, o sticky vem do ScrollContainer

const AssignDeviceModal: React.FC<AssignDeviceModalProps> = ({
  open,
  onClose,
  onDeviceAssigned,
  clientId,
  workOrderId
}) => {
  const [serial, setSerial] = useState("");
  const [results, setResults] = useState<any[]>([]);

  // busca sempre que serial ou open mudarem
  useEffect(() => {
    if (!open) return;
    (async () => {
      try {
        const { data } = await api.get(
          `/devices/all?client_id=${clientId}${
            serial ? `&serial=${serial}` : ""
          }`
        );
        setResults(data);
      } catch {
        setResults([]);
      }
    })();
  }, [open, serial]);

  const handleAssign = async (deviceId: number) => {
    try {
      await api.post(`/work-order/${workOrderId}/devices/${deviceId}`);
      // setSnackbar({ open: true, message: 'Equipamento associado!', severity: 'success' });
      setResults((r) => r.filter((d) => d.device_id !== deviceId));

      ToastSuccess(`Equipemento associado a ordem de serviço com sucesso!`);

      onDeviceAssigned();
    } catch (e: any) {
      ToastError(e?.response?.data?.message || "Erro ao associar.");
    }
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <ModalBody>
          <h2>Associar Equipamento</h2>

          <SearchContainer>
            <TextField
              label="Buscar por Série"
              fullWidth
              size="small"
              margin="dense"
              value={serial}
              onChange={(e) => setSerial(e.target.value)}
            />
          </SearchContainer>

          <TableContainer>
            <StyledTable>
              <thead>
                <tr>
                  <th>Nome / Modelo</th>
                  <th>Número de Série</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                {results.map((dev) => (
                  <tr key={dev.device_id}>
                    <td>
                      {dev.device_name} / {dev.device_model}
                    </td>
                    <td>{dev.device_serial_number}</td>
                    <td>
                      <CustomTooltip title="Associar Equipamento">
                        <MdLibraryAdd
                          color="#03F"
                          style={{ cursor: "pointer" }}
                          size={18}
                          onClick={() => handleAssign(dev.device_id)}
                        />
                      </CustomTooltip>
                    </td>
                  </tr>
                ))}
                {results.length === 0 && (
                  <tr>
                    <td
                      colSpan={3}
                      style={{ textAlign: "center", padding: "16px" }}
                    >
                      Nenhum equipamento encontrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </StyledTable>
          </TableContainer>

          <ActionsContainer>
            <Button onClick={onClose} color="secondary">
              Fechar
            </Button>
          </ActionsContainer>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AssignDeviceModal;
